/*//////////////////////*/
/* Imports
/*/ /////////////////////*/
import { useEffect, useRef, useState, useMemo } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getContentReducer } from "../../store/content/content.selector";
import { setFromPage } from "../../store/lot/lot.reducer";
import { ArrowRight } from "../../icons/ArrowRight.icon";
import { SurfaceIcon } from "../../icons/Surface.icon";
import { BatimentIcon } from "../../icons/Batiment.icon";
import { EtageIcon } from "../../icons/Etage.icon";
import { OptionsIcon } from "../../icons/Options.icon";
import { OrientationIcon } from "../../icons/Orientation.icon";
import { TypeIcon } from "../../icons/Type.icon";
import { PrixIcon } from "../../icons/Prix.icon";
import { EyeIcon } from "../../icons/Eye.icon";
import "./Lot.styles.scss";

import {getScale} from "../../utils/helpers.utils";
import {getProjectsReducer} from "../../store/projects/projects.selector";

const Lot = ({
  lot,
  ecranLot,
  ecranGroup,
  allChecked,
  updateEcranLot,
  udpdateEcranGroup,
  updateSelectedLots,
  programmeDatas,
}) => {
  /*//////////////////////*/
  /* Variables
  /*/ /////////////////////*/
  const dispatch = useDispatch();
  const { pathname, search } = useLocation();
  const { projectID, scaleID } = useParams();
  const checked = useRef(true);
  const [name, setName] = useState(null);
  const [url, setURL] = useState(null);
  const {
    texts: {
      searchLotButton,
      searchLotButtonLocalize,
      searchLotButtonUnlocalize,
    },
  } = useSelector(getContentReducer);
  const projectsReducer = useSelector(getProjectsReducer);
  const scale = useMemo(
    () => getScale(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const [filters, setFilters] = useState(null)


  /*//////////////////////*/
  /* Effects
  /*/ /////////////////////*/


  useEffect(() => {
    if (scale && scale?.lotsFilters?.data?.attributes?.url) {
      fetch(`https://strapi-tzjc.onrender.com${scale?.lotsFilters?.data?.attributes?.url}`)
      .then(response => response.text())
      .then(csv => {
        const legendsCSV = csv.split("\r\n")[0].split(",")
        const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))

        const legendsDatas = []

        parsedCSV.map(legend => {
          const legendDatas = {}

          legendsCSV.map((v, i) => {
            legendDatas[v] = i !== 2 ? legend[i] : legend[i].split("|").map(option => { return {value : option, label : option}})
          })

          legendsDatas.push(legendDatas)
        })

        setFilters(legendsDatas)
      })
    }
  }, [scale])







  useEffect(() => {
    checked.current = allChecked;
  }, [allChecked]);

  useEffect(() => {
    if (programmeDatas && programmeDatas?.name) setName(programmeDatas.name);
    if (programmeDatas && programmeDatas?.url) setURL(programmeDatas.url);
  }, [programmeDatas]);

  /*//////////////////////*/
  /* Functions
  /*/ /////////////////////*/
  const lotClick = () => {
    checked.current = !checked.current;
    if (lot && lot?.nom) {
      updateSelectedLots(lot.nom, checked.current);
    }
  };

  const getIconFromLot = (icon) => {
    
    switch (icon) {
      case "PrixIcon":
        return <PrixIcon />
      case "SurfaceIcon":
        return <SurfaceIcon />
      case "TypeIcon":
        return <TypeIcon />
      case "EtageIcon":
        return <EtageIcon />
      case "BatimentIcon":
        return <BatimentIcon />
      case "OrientationIcon":
        return <OrientationIcon />
      case "OptionsIcon":
        return <OptionsIcon />
    }
  }

  /*//////////////////////*/
  /* Return
  /*/ /////////////////////*/
  return (
    filters && 
    <article
      className={`lot lot--notfull ${
        (ecranLot === lot.nom || ecranGroup === lot.groupe) && "lot--selected"
      } h-full`}
    >
      <div
        className="lot__heading | text-center cursor-pointer"
        onClick={lotClick}
      >
        <div
          className={`relative flex items-center ${
            lot.statut === "Disponible" ? "justify-between" : "justify-start"
          }`}
        >
          <div className = {`eye ${checked?.current ? "selected" : "regular"}`} style = {{width : "29px", marginRight : "30px", marginLeft : "12px"}}>
            <EyeIcon height = {20}/>
          </div>
          
          <strong className="text-white z-10 uppercase bold text-lg">
            {lot.nom}
          </strong>
          {lot.statut === "Disponible" && (
            <span className="lot__dispo opacity-80 text-sm">{lot.statut}</span>
          )}
        </div>
      </div>

      <div
        className={`lot__body | flex content-between ${
          !lot.printed && name && url ? "pt-4 px-4" : "p-2"
        }`}
      >
        <div className="flex items-center cursor-pointer" onClick={lotClick}>
          {/* <CheckedIcon checked={checked?.current} /> */}
          <input
            type="checkbox"
            checked={checked?.current}
            onChange={() => {}}
          />
          <hr />
          <div>

            <div className="flex flex-wrap">

              {filters.filter(x => x.display === "true").map(filter => 
                <div className="lot__details" style = {{fontSize : "13.5px"}}>
                  {getIconFromLot(filter.icon)}
                  <span>{(lot[filter.nom] == "" || isNaN(lot[filter.nom])) ? lot[filter.nom] : parseFloat(lot[filter.nom]).toLocaleString("fr-FR", {})}{filter.suffix}</span>
                </div>
              )}

            </div>
          </div>
        </div>

        <footer className="w-full button-parent mt-4 z-20">
          <div style = {{display : "flex", "gap" : "4px"}}>
            <button
              className={`button button--${ ecranLot === lot.nom ? "primary" : "secondary" } relative`}
              onClick={() =>
                updateEcranLot(lot?.nom, ecranLot !== lot.nom ? true : false)
              }
            >
              {searchLotButtonLocalize}
              {/* {ecranLot !== lot.nom
                ? searchLotButtonLocalize
                : searchLotButtonUnlocalize} */}
            </button>
            <button
              className={`button button--${ ecranGroup === lot.groupe ? "primary" : "secondary" } relative`}
              onClick={() =>
                udpdateEcranGroup(lot?.groupe, ecranGroup !== lot.groupe ? true : false)
              }
            >
              {searchLotButtonUnlocalize}
            </button>
          </div>

          {!lot.printed && name && url && (
            <div className="flex justify-end">
              <a
                href={`https://${url}.3d.virtualbuilding.fr/${name}/detail-lot/${lot.nom}/plan`}
                target="_blank"
                rel="noreferrer"
                className="arrow py-4 pl-4"
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <ArrowRight className="icon" />
              </a>
            </div>
          )}

          {lot.printed && (
            <div
              className="mt-4"
              onClick={() => {
                dispatch(setFromPage(pathname + search));
              }}
            >
              <Link className="button text-center" to={`${lot.nom}${window?.location?.search}`}>
                {searchLotButton}
              </Link>
            </div>
          )}
        </footer>
      </div>
    </article>
  );
};

export default Lot;
